export function sampleAdminUserSummary(): Record<string, unknown> {
  return {
    id: 'user-id',
    name: 'Admin User',
    email: 'admin@example.com'
  }
}
